import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import Reveal from "../Reveal";

const STEPS = ["discover", "strategy", "execute", "optimize"];

export default function ProcessSteps() {
  const { t } = useLanguage();

  return (
    <section
      id="about"
      data-testid="process-section"
      className="relative bg-cream py-section sm:py-section-lg border-t border-mist"
    >
      <div className="container-page">
        <Reveal as="div" className="max-w-2xl">
          <span className="eyebrow">
            <span className="h-1 w-1 rounded-full bg-gold" />
            {t("process.eyebrow")}
          </span>
          <h2 className="mt-5 font-display text-display-2 font-semibold text-ink">
            {t("process.title_pre")}{" "}
            <span className="gold-foil-text">{t("process.title_accent")}</span>
          </h2>
          <p className="mt-5 text-body-lg text-ink/65 max-w-xl leading-relaxed">
            {t("process.subtitle")}
          </p>
        </Reveal>

        <div
          className="mt-16 grid gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-6 relative"
          data-testid="process-grid"
        >
          {/* Dotted connector line on desktop */}
          <div
            className="hidden lg:block absolute top-[42px] start-[12.5%] end-[12.5%] h-px border-t border-dashed border-gold/40"
            aria-hidden="true"
          />
          {STEPS.map((s, i) => (
            <Reveal as="div" key={s} delay={i * 0.1} className="relative">
              <div
                className="font-display text-display-2 font-semibold gold-foil-text leading-none"
                data-testid={`process-step-${i + 1}`}
              >
                {String(i + 1).padStart(2, "0")}
              </div>
              <h3 className="mt-5 font-display text-h2 font-semibold text-ink">
                {t(`process.steps.${s}.title`)}
              </h3>
              <p className="mt-3 text-sm text-ink/65 leading-relaxed max-w-[28ch]">
                {t(`process.steps.${s}.desc`)}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
